import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import {
    FileImageOutlined,
    EyeOutlined,
    HeartOutlined
} from '@ant-design/icons';
import { Row, Col, Button, Collapse, Spin, Alert } from 'antd';
import PropertiesItem from './PropertiesItem'
import axios from 'axios'
import BuyNftImg from './BuyNftImg'
import { DateTime } from 'luxon';
import useNFTPrice from '../../hooks/useNFTPrice';
import NumberFormat from 'react-number-format';
import { toast } from 'react-toastify';
import { useWeb3React } from '@web3-react/core';
import { approveBUSDForMinting, mintYourNFT, isWalletAddressWhiteListedByCategory } from '../../blockchain/web3.service';
import useNFTSoldStatus from '../../hooks/useNFTSoldStatus';
export default function BuyNftDetails() {

    const { Panel } = Collapse;
    const params = useParams();
    const [isNFTLoading, setIsNFTLoading] = useState(false)
    const [nftData, setNftData] = useState({})
    const [isMintNFTButtonDisabled, setIsMintNFTButtonDisabled] = useState(true)
    const [isBUSDApprovingLoading, setIsBUSDApprovingLoading] = useState(false)
    const [isMintingNFTLoading, setIsMintingNFTLoading] = useState(false)
    const [isWhiteListed, setIsWhiteListed] = useState(false)
    const [isWhiteListedDetailsLoading, setIsWhiteListedDetailsLoading] = useState(false)

    const { isLoading: nftPriceLoading, nftPrice } = useNFTPrice({ category: nftData?.type })
    const { isLoading: nftSoldDetailsLoading, isSold } = useNFTSoldStatus({ tokenID: nftData?.id })
    const { account, library } = useWeb3React()


    useEffect(() => {

        if (account && nftData) {
            fetchWhiteListedDetails()
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [account, nftData])

    const fetchWhiteListedDetails = async () => {
        setIsWhiteListedDetailsLoading(true)
        try {
            const isWhiteListedResponse = await isWalletAddressWhiteListedByCategory(nftData?.type, account)
            setIsWhiteListed(isWhiteListedResponse)
            setIsWhiteListedDetailsLoading(false)
        } catch (error) {
            console.error("ERROR while fetching NFT whitelisted details ", error)
            setIsWhiteListedDetailsLoading(false)
            setIsWhiteListed(false)
        }
    }

    const handleApproveBUSD = async () => {

        setIsBUSDApprovingLoading(true)
        try {
            if (!account) {
                toast.error("Please connect your wallet to continue")
                setIsBUSDApprovingLoading(false)
                return
            }

            if (!nftPrice) {
                toast.error("Can not determine the price of given NFT please try again")
                setIsBUSDApprovingLoading(false)
                return
            }

            const result = await approveBUSDForMinting(nftPrice, library.getSigner())
            if (result) {
                toast.success("BUSD approval has been completed please proceed with minting step")
            }
            setIsBUSDApprovingLoading(false)
            setIsMintNFTButtonDisabled(false)
        } catch (error) {
            setIsBUSDApprovingLoading(false)
            setIsMintNFTButtonDisabled(true)
            toast.error("Something went wrong while approving BUSD")
            console.error("ERROR while trying to approve BUSD for minting", error)
        }
    }

    const handleMintYourNFT = async () => {
        setIsMintingNFTLoading(true)
        try {
            if (!account) {
                toast.error("Please connect your wallet to continue")
                setIsMintingNFTLoading(false)
                return
            }

            if (!nftPrice) {
                toast.error("Can not determine the price of given NFT please try again")
                setIsMintingNFTLoading(false)
                return
            }

            if (!nftData) {
                toast.error("NFT data not found Please try again later")
                setIsMintingNFTLoading(false)
                return
            }

            const metaDataBaseURI = 'https://h4g.mypinata.cloud/ipfs/QmZ4YWijATu8d7ViHpR51j6tpHjmDiaavj73BK79DN2Avc/'
            const result = await mintYourNFT(nftData, metaDataBaseURI, account, library.getSigner())
            if (result) {
                let message = `Your G Dragon NFT #${nftData?.id} has been minted.`
                toast.success(message)
            }
            setIsMintingNFTLoading(false)
        } catch (error) {
            setIsMintingNFTLoading(true)
            toast.error("Something went wrong while minting your NFT")
            console.error("ERROR while trying to mint your NFT", error)
        }
    }

    const fetchSingleNFTData = async (id) => {
        try {
            setIsNFTLoading(true)
            const endpoint = `https://h4g.mypinata.cloud/ipfs/QmZ4YWijATu8d7ViHpR51j6tpHjmDiaavj73BK79DN2Avc/${id}.json`
            const response = await axios.get(endpoint)
            if (response.status === 200) {
                const nftData = response.data

                if (nftData) {
                    setNftData(nftData)
                } else {
                    setNftData({})
                }
            } else {
                setNftData({})
            }
            setIsNFTLoading(false)
        } catch (error) {
            console.error("ERROR : while fetching NFT data from the API ", error)
            setNftData({})
            setIsNFTLoading(false)
        }
    }

    const getImageURL = (data) => {
        if (data) {
            const ipfsURL = data
            return ipfsURL.replace("ipfs://", "https://h4g.mypinata.cloud/ipfs/")
        } else {
            return null
        }
    }

    useEffect(() => {
        if (params.id) {
            fetchSingleNFTData(params.id)
        }
    }, [params])

    return (
        <div>
            <Row className='mt-5'>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <BuyNftImg image={getImageURL(nftData.image)} />
                </Col>

                {
                    isNFTLoading ? (
                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <div className='d-flex justify-content-center'>
                                <Spin size='large' />
                            </div>
                        </Col>
                    ) : (
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <div className="item_info">
                                Token Created At
                                <div className="de_countdown">
                                    {nftData ? DateTime.fromMillis(parseInt(nftData.date)).toFormat("dd MMM yyyy, hh:mm a") : 'N/A'}
                                </div>
                                <h2>{nftData ? nftData.name : 'N/A'}</h2>
                                <span className="nft-selling-price">
                                    {
                                        nftPriceLoading ? (
                                            <div className='d-flex'>
                                                <Spin size='small' />
                                            </div>
                                        ) : (
                                            <>
                                                <NumberFormat
                                                    value={nftPrice ? nftPrice : 0.00}
                                                    displayType="text"
                                                    suffix=' BUSD'
                                                    decimalScale={4}
                                                    thousandSeparator={true}
                                                />
                                            </>
                                        )
                                    }
                                </span>
                                <div className="item_info_counts mt-3">
                                    <div className="item_info_type"><FileImageOutlined className='mr-1' />ERC721</div>
                                    <div className="item_info_views"><EyeOutlined className='mr-1' />Token ID # {nftData ? nftData.id : 'N/A'}</div>
                                    <div className="item_info_like"><HeartOutlined className='mr-1' />Token Symbol : DRAGON</div>
                                </div>
                                <h5>{nftData ? nftData.description : 'N/A'}</h5>

                                <div className="spacer-40"></div>

                                <div className='mb-3'>
                                    <Collapse defaultActiveKey={['1']} expandIconPosition={'end'}>
                                        <Panel header="Properties" key="1">
                                            <Row>
                                                {
                                                    isNFTLoading ? (
                                                        <div className='d-flex justify-content-center'>
                                                            <Spin size='large' />
                                                        </div>
                                                    ) : (
                                                        <>
                                                            {
                                                                nftData?.attributes?.map((item, index) => (
                                                                    <Col key={index} xs={12} sm={12} md={8} lg={8} xl={8} className='property-col'>
                                                                        <PropertiesItem traitType={item.trait_type} value={item.value} />
                                                                    </Col>
                                                                ))
                                                            }
                                                        </>
                                                    )
                                                }
                                            </Row>
                                        </Panel>
                                    </Collapse>
                                </div>

                                {
                                    <>
                                        {
                                            account ? (
                                                isWhiteListedDetailsLoading || nftSoldDetailsLoading ? (
                                                    <div className='d-flex justify-content-center mt-4'>
                                                        <Spin />
                                                    </div>
                                                ) : (
                                                    <>

                                                        {
                                                            isSold ? (

                                                                <Alert
                                                                    message="NFT Minted"
                                                                    description={`${nftData?.name} #${nftData?.id} already sold out, try a new one`}
                                                                    type="warning"
                                                                    showIcon

                                                                />

                                                            ) : (
                                                                <>
                                                                    {
                                                                        isWhiteListed ? (
                                                                            <div className='d-flex content-start'>
                                                                                <div className='approve-btn'>
                                                                                    <Button
                                                                                        className='approve-busd-btn'
                                                                                        shape="round"
                                                                                        loading={isBUSDApprovingLoading}
                                                                                        onClick={handleApproveBUSD}
                                                                                        style={{ marginRight: '10px' }}
                                                                                    >
                                                                                        Approve BUSD
                                                                                    </Button>
                                                                                </div>

                                                                                <div className='mint-nft-btn'>
                                                                                    <Button
                                                                                        className='mint-nft-btn'
                                                                                        shape="round"
                                                                                        onClick={handleMintYourNFT}
                                                                                        loading={isMintingNFTLoading}
                                                                                        disabled={isMintNFTButtonDisabled}
                                                                                    >
                                                                                        Mint Your NFT
                                                                                    </Button>
                                                                                </div>
                                                                            </div>
                                                                        ) : (
                                                                            <Alert
                                                                                message="Account Details"
                                                                                description="Your address is not whitelisted yet. Please try again later"
                                                                                type="warning"
                                                                                showIcon

                                                                            />
                                                                        )
                                                                    }
                                                                </>
                                                            )
                                                        }

                                                    </>
                                                )
                                            ) : (
                                                <Alert
                                                    message="Account Details"
                                                    description="Please connect your wallet to mint the NFT"
                                                    type="warning"
                                                    showIcon

                                                />
                                            )
                                        }

                                    </>

                                }

                            </div>
                        </Col>
                    )
                }

            </Row>

        </div>
    )
}